import { ResponsivePleaseWait } from '.';
// Calibration / distance tabs use the IBISengage patient screens (P3-P6) in the SessionLayout.
import {
  PatientScreenCalibration,
  PatientCardCalibration,
  PatientRulerCalibration,
  PatientCameraCalibration,
  PatientDistance,
} from '../session/calibration/PatientCalibrationScreens';
import { ResponsiveLogmarTestPatient } from './Logmar';
import { ResponsiveRandomETestPatient } from './RandomE';
import { ResponsiveOptimaChartTestPatient } from './OptimaChart';
import { ResponsiveContrastSensitivityTestPatient } from './ContrastSensitivity';
import { ResponsiveRefractionTestPatient } from './Refraction';
import { ResponsiveRefractionTwoTestPatient } from './RefractionTwo';
import { MultiplePatient, ResponsiveKaysOptotypesTestPatient } from './KaysOptotypes';
import ColourVisionPlate from '../patient/colour-vision-plate';

const ResponsiveContentPatient = ({
  blindSpotData,
  setBlindSpotData,
  blindSpotUpdateMessage,
  setBlindSpotUpdateMessage,
  movementNotification,
  logmarData,
  logmarType,
  activeTab,
  setActiveTab,
  calibrationStep,
  optimaData,
}) => {
  const contentOptions = [
    { id: 'screen-calibration', content: <PatientScreenCalibration /> },
    { id: 'camera-calibration', content: <PatientCameraCalibration /> },
    { id: 'ruler', content: <PatientRulerCalibration /> },
    { id: 'card', content: <PatientCardCalibration /> },
    {
      id: 'logmar',
      content: <ResponsiveLogmarTestPatient movementNotification={movementNotification} logmarData={logmarData} logmarType={logmarType} />,
    },
    {
      id: 'randomE',
      content: <ResponsiveRandomETestPatient movementNotification={movementNotification} logmarData={logmarData} />,
    },
    {
      id: 'optimaChart',
      content: <ResponsiveOptimaChartTestPatient optimaData={optimaData} />,
    },
    // {
    //   id: 'visualField',
    //   content: (
    //     <VisualField
    //       movementNotification={movementNotification}
    //       visualFieldTestControl={visualFieldTestControl}
    //       testNotification={testNotification}
    //     />
    //   ),
    // },
    // {
    //   id: 'visualFieldForthValley',
    //   content: <VisualFieldForthValley />,
    // },
    {
      id: 'contrastSensitivity',
      content: <ResponsiveContrastSensitivityTestPatient movementNotification={movementNotification} logmarData={logmarData} />,
    },
    {
      id: 'refraction',
      content: <ResponsiveRefractionTestPatient />,
    },
    {
      id: 'refractionTwo',
      content: <ResponsiveRefractionTwoTestPatient />,
    },
    {
      id: 'kaysOptotypes',
      content: <ResponsiveKaysOptotypesTestPatient />,
    },
    {
      id: 'kaysMultiple',
      content: <MultiplePatient />,
    },
    // {
    //   id: 'holding',
    //   content: <Holding />,
    // },
    // {
    //   id: 'endOfTest',
    //   content: <EndOfTest />,
    // },
    {
      id: 'pupillaryDistance',
      content: <PatientDistance />,
    },
    { id: 'ishihara', content: <ColourVisionPlate /> },
  ];

  const selectedContent = contentOptions.find((selectedTab) => {
    return activeTab === selectedTab.id;
  });

  return selectedContent?.content || <ResponsivePleaseWait />;
};

export default ResponsiveContentPatient;
